import { useState } from 'react';
import razorpaySrc      from '@/assets/razorpay.svg';
import stripeSrc        from '@/assets/stripe.svg';
import shiprocketSrc    from '@/assets/shiprocket.png';
import delhiverySrc     from '@/assets/delhivery.png';
import wishlistPlusSrc  from '@/assets/wishlist-plus.svg';
import growaveSrc       from '@/assets/growave.svg';
import wishlistHeroSrc  from '@/assets/wishlist-hero.png';
import rechargeSrc      from '@/assets/recharge.svg';
import yotpoSrc         from '@/assets/yotpo.png';
import gorgiasSrc       from '@/assets/gorgias.png';

type Logo = {
  name: string;
  src: string;
  glyph: string;
  color: string;
};

const LOGOS: Logo[] = [
  { name: 'Razorpay',      src: razorpaySrc,     glyph: 'R',  color: '#3395ff' },
  { name: 'Stripe',        src: stripeSrc,       glyph: 'S',  color: '#635bff' },
  { name: 'Shiprocket',    src: shiprocketSrc,   glyph: 'SR', color: '#5b3df5' },
  { name: 'Delhivery',     src: delhiverySrc,    glyph: 'D',  color: '#cf2027' },
  { name: 'Wishlist Plus', src: wishlistPlusSrc, glyph: 'W+', color: '#1a83b0' },
  { name: 'Growave',       src: growaveSrc,      glyph: 'G',  color: '#8e3ae5' },
  { name: 'Wishlist Hero', src: wishlistHeroSrc, glyph: 'WH', color: '#ec4081' },
  { name: 'ReCharge',      src: rechargeSrc,     glyph: 'R',  color: '#00b88a' },
  { name: 'Yotpo',         src: yotpoSrc,        glyph: 'Y',  color: '#0042ff' },
  { name: 'Gorgias',       src: gorgiasSrc,      glyph: 'G',  color: '#7b61ff' },
];

function LogoMark({ logo }: { logo: Logo }) {
  const [errored, setErrored] = useState(false);
  if (!errored) {
    return (
      <img
        src={logo.src}
        alt=""
        width="72"
        height="72"
        loading="lazy"
        onError={() => setErrored(true)}
        style={{ objectFit: 'contain', borderRadius: 4 }}
      />
    );
  }
  return (
    <span
      aria-hidden
      style={{
        width: 72,
        height: 72,
        borderRadius: 12,
        background: logo.color,
        color: '#fff',
        fontSize: 24,
        fontWeight: 800,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        letterSpacing: '.02em',
      }}
    >
      {logo.glyph}
    </span>
  );
}

export function LogoStrip() {
  return (
    <section className="lp-strip">
      <div className="mx-auto w-full max-w-[1180px] px-7">
        <div className="lp-strip-label reveal">
          WORKS WITH THE TOOLS YOUR STORE ALREADY RUNS ON
        </div>
        <div className="lp-marquee reveal" aria-label="Integrations">
          <div className="lp-marquee-track">
            {LOGOS.map((l) => (
              <div className="lp-logo-pill" key={`a-${l.name}`} title={l.name} aria-label={l.name}>
                <LogoMark logo={l} />
              </div>
            ))}
            {LOGOS.map((l) => (
              <div className="lp-logo-pill" key={`b-${l.name}`} aria-hidden>
                <LogoMark logo={l} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
